import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div data-testid="auth-loading" className="flex min-h-screen items-center justify-center text-sm text-[#4B5563]">
        Checking your session…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
};
